import React, { Suspense, useState } from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import ProtectedRoute from "./ProtectedRoute";
import AuthCard from "../pages/authCard/AuthCard";
import OCAllInRoutes from "./oc-all-in-routes/OC-All-In_Routes";
import SuperAdmin_Routes from "./super-admin_routes/SuperAdmin_Routes";
import PLCRoutes from "./plc-routes/PLC-routes";
import DTSRoutes from "./dts-routes/DTS-routes";
import ThirtyForThirtyRoutes from "./30-for-30-routes/Thirty-for-thirty-routes";

export interface UserData {
  accessToken: string;
  email: string;
  firstName: string;
  lastName: string;
  id: string;
  isActive: boolean;
  role: string;
  userType: string;
}

const AppRoutes = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<UserData | null>(null);

  const Login = React.lazy(() => import("../pages/auth/login/Login"));
  const DeactivateAccount = React.lazy(
    () => import("../pages/public/deactivate-account/DeactivateAccount"),
  );
  const DeactivateAccountConfirm = React.lazy(
    () =>
      import("../pages/public/deactivate-account/DeactivateAccountConfirm"),
  );
  // const MainPage = React.lazy(() => import("../pages/main-pages/MainPage"));
  // const TermData = React.lazy(
  //   () => import("../pages/main-pages/term-data/TermData"),
  // );
  // const Events = React.lazy(
  //   () => import("../pages/main-pages/events/list/EventsList"),
  // );
  // const Employees = React.lazy(
  //   () => import("../pages/main-pages/employees/list/EmployeeList"),
  // );
  // const Rewards = React.lazy(
  //   () => import("../pages/main-pages/rewards/Rewards"),
  // );
  // const Reports = React.lazy(
  //   () => import("../pages/main-pages/reports/Reports"),
  // );

  // const FAQManagement = React.lazy(
  //   () => import("../pages/main-pages/FAQ-management/list/FAQManagementList"),
  // );

  return (
    <Suspense>
      <Routes>
        <Route
          path="/login"
          element={<Login setIsAuthenticated={setIsAuthenticated} />}
        />
        <Route path="/deactivate-account" element={<DeactivateAccount />} />
        <Route
          path="/deactivate-account/confirm"
          element={<DeactivateAccountConfirm />}
        />
        <Route path="/" element={<Navigate to="/login" />} />
        <Route
          path="/home"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <AuthCard
                isAuthenticated={isAuthenticated}
                setIsAuthenticated={setIsAuthenticated}
              />
              {/* <MainPage setIsAuthenticated={setIsAuthenticated} /> */}
            </ProtectedRoute>
          }
        >
          <Route index element={<Navigate to="/home" replace />} />
          {/* <Route index element={<Navigate to="term-data" replace />} /> */}
          {/* <Route path="/term-data" element={<TermData />} />
          <Route path="/events" element={<Events />} />
          <Route path="/employees" element={<Employees />} />
          <Route path="/rewards" element={<Rewards />} />
          <Route path="/reports" element={<Reports />} />
          <Route path="/faq-management" element={<FAQManagement />} /> */}
        </Route>

        <Route
          path="/super-admin/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <SuperAdmin_Routes setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/oc-all-in/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <OCAllInRoutes setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/plc/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <PLCRoutes setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/dts/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <DTSRoutes setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />

        <Route
          path="/thirty-for-thirty/*"
          element={
            <ProtectedRoute isAuthenticated={isAuthenticated}>
              <ThirtyForThirtyRoutes setIsAuthenticated={setIsAuthenticated} />
            </ProtectedRoute>
          }
        />
      </Routes>
    </Suspense>
  );
};

export default AppRoutes;
